import { render, staticRenderFns } from "./DVclassSelect.vue?vue&type=template&id=d2611f9e&scoped=true"
import script from "./DVclassSelect.vue?vue&type=script&lang=js"
export * from "./DVclassSelect.vue?vue&type=script&lang=js"
import style0 from "./DVclassSelect.vue?vue&type=style&index=0&id=d2611f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2611f9e",
  null
  
)

export default component.exports